import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PrivacyPage.css"
import BottomContact from "./BottomContact";

const PrivacyPage: React.FC = () => {

    return (
        <div className="privacy-wrapper">
            <div className="privacy-content">
                <h1>Política de Privacidad</h1>

                <h5>Última actualización: 3 de febrero de 2025</h5>

                Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza el servicio y le informa sobre sus derechos de privacidad y cómo la ley le protege.

                Usamos sus datos personales para proporcionar y mejorar el servicio. Al utilizar el servicio, usted acepta la recopilación y el uso de la información de acuerdo con esta Política de Privacidad.

                <h2>Interpretación y Definiciones</h2>

                <h4>Interpretación</h4>

                Las palabras con la primera letra en mayúscula tienen significados definidos en las siguientes condiciones. Las siguientes definiciones tendrán el mismo significado independientemente de si aparecen en singular o en plural.

                <h4>Definiciones</h4>

                A efectos de esta Política de Privacidad:

                <ul>
                    <li>Cuenta significa una cuenta única creada para que usted acceda a nuestro servicio o a partes de nuestro servicio.</li>

                    <li>Afiliado significa una entidad que controla, es controlada o está bajo control común con una parte, donde "control" significa la propiedad del 50% o más de las acciones, participaciones o valores con derecho a voto para la elección de directores u otra autoridad de gestión.</li>

                    <li>Empresa (referida como "la Empresa", "Nosotros", "Nos" o "Nuestro" en este Acuerdo) se refiere a Amaya Castillo Nutrition.</li>

                    <li>Cookies son pequeños archivos que se colocan en su dispositivo por un sitio web, que contienen detalles de su historial de navegación en ese sitio web, entre otros usos.</li>

                    <li>País se refiere a: España.</li>

                    <li>Dispositivo significa cualquier dispositivo que pueda acceder al servicio, como una computadora, un teléfono móvil o una tableta digital.</li>

                    <li>Datos Personales es cualquier información que se relacione con un individuo identificado o identificable.</li>

                    <li>Servicio se refiere al sitio web.</li>

                    <li>Proveedor de Servicios significa cualquier persona física o jurídica que procese los datos en nombre de la Empresa. Se refiere a empresas o individuos externos contratados para facilitar el servicio, proporcionar el servicio en nombre de la Empresa o analizar el uso del servicio.</li>

                    <li>Datos de Uso se refieren a los datos recopilados automáticamente, ya sea generados por el uso del servicio o desde la infraestructura del propio servicio (por ejemplo, la duración de una visita a una página).</li>

                    <li>Sitio Web se refiere a Amaya Castillo Nutrition, accesible desde https://amayacastillonutrition.com.</li>

                    <li>Usted se refiere a la persona que accede o usa el servicio, o la empresa u otra entidad legal en nombre de la cual dicha persona accede o usa el servicio.</li>
                </ul>

                <h2>Recopilación y Uso de sus Datos Personales</h2>

                <h4>Tipos de Datos Recopilados</h4>

                <h5>Datos Personales</h5>

                Al utilizar nuestro servicio, podemos solicitarle que nos proporcione cierta información personal identificable que puede ser utilizada para contactarlo o identificarlo. La información personal identificable puede incluir, entre otros:
                <ul>
                    <li>Dirección de correo electrónico</li>

                    <li>Nombre y apellidos</li>

                    <li>Número de teléfono</li>

                    <li>Datos de Uso</li>
                </ul>
                <h5>Datos de Uso</h5>

                Los datos de uso se recopilan automáticamente cuando se utiliza el servicio e incluyen información como la dirección IP de su dispositivo, tipo y versión del navegador, páginas visitadas, fecha y hora de la visita, tiempo de permanencia en las páginas y otros datos de diagnóstico.

                Cuando accede al servicio a través de un dispositivo móvil, podemos recopilar información como el tipo de dispositivo, identificador único del dispositivo, dirección IP, sistema operativo móvil y navegador móvil utilizado.

                <h5>Tecnologías de Seguimiento y Cookies</h5>

                Usamos cookies y tecnologías similares para rastrear la actividad en nuestro servicio y almacenar cierta información. Puede configurar su navegador para rechazar todas las cookies o para indicar cuando una cookie está siendo enviada. Sin embargo, si no acepta cookies, es posible que no pueda utilizar algunas partes de nuestro servicio.

                Tipos de cookies utilizadas:

                <ul>
                    <li>Cookies esenciales: necesarias para el funcionamiento del sitio.</li>

                    <li>Cookies de aceptación: identifican si los usuarios han aceptado el uso de cookies en el sitio.</li>

                    <li>Cookies de funcionalidad: recuerdan preferencias del usuario para mejorar la experiencia de navegación.</li>
                </ul>
                Para obtener más información sobre las cookies que usamos y sus opciones, visite nuestra Política de Cookies.

                <h2>Uso de sus Datos Personales</h2>

                La Empresa puede utilizar los Datos Personales para los siguientes propósitos:
                <ul>
                    <li>Proporcionar y mantener nuestro servicio, incluyendo el monitoreo de su uso.</li>

                    <li>Gestionar su cuenta como usuario del servicio.</li>

                    <li>Cumplimiento de contratos para la compra de productos o servicios.</li>

                    <li>Comunicarnos con usted por correo electrónico, teléfono, SMS u otras formas de contacto.</li>

                    <li>Enviarle ofertas y noticias sobre productos y servicios similares a los que ha adquirido o consultado.</li>

                    <li>Gestionar solicitudes que nos envíe.</li>
                </ul>

                Podemos compartir su información con:
                <ul>
                    <li>Proveedores de servicios que nos ayuden con el funcionamiento de nuestro sitio.</li>

                    <li>Afiliados y socios comerciales.</li>

                    <li>Autoridades legales, si es necesario para cumplir con obligaciones legales.</li>
                </ul>

                <h2>Retención y Eliminación de sus Datos Personales</h2>

                Mantenemos sus datos solo el tiempo necesario para los fines establecidos en esta política. Puede solicitar la eliminación de sus datos en cualquier momento enviándonos un correo a amayacastillo.nutrition@gmail.com.

                <h2>Seguridad de sus Datos</h2>

                Protegemos sus datos personales con medidas de seguridad adecuadas, aunque no podemos garantizar su seguridad absoluta.

                <h2>Derechos de los Usuarios</h2>

                Tiene derecho a:
                <ul>
                    <li>Acceder, corregir o eliminar sus datos personales.</li>

                    <li>Oponerse al procesamiento de sus datos.</li>

                    <li>Presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) o la autoridad de protección de datos de su país.</li>
                </ul>
                <h2>Contacto</h2>

                Si tiene preguntas sobre esta Política de Privacidad, puede contactarnos:
                <ul>
                    <li>Correo electrónico: amayacastillo.nutrition@gmail.com</li>

                    <li>Teléfono: +34 626 985 035</li>

                    <li>Web: https://amayacastillonutrition.com</li>
                </ul>
            </div>
            <div>
                <BottomContact />
            </div>
        </div>
    );
};

export default PrivacyPage;
